export function buildWhatsappLink(phoneRaw: string, message: string): string {
  const phone = phoneRaw.replace(/\D/g, "");
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
